export const Update = {
  CREATE_UPDATE: 'update/create-update-queue', // Cria uma nova atualização
  AREA_LIST_SIMPLE: 'update/areas/simple', // Retorna todas áreas tecnológicas de uma versão (opcional), sem modalidades
  UPDATING_OR_CURRENT_VERSION:
    'update/versions/find-version-updating-or-current', // Retorna versão em atualização ou atual caso não haja versão em atualização
  UPDATE_STATUS: 'update/read-update-queue-status', // Retorna status da fila de atualização
  UPDATE_PUBLISH: '/update/versions/publish',
  AREA_LIST: 'update/areas',
  AREA_ID: 'update/areas/{areaId}', // Retorna área tecnológica específica
  AREA_ID_FINALIZE: 'update/area-version/{areaId}/finalize',
  PUBLISH_UPDATING_COURSES_FROM_AREA:
    'update/area-version/{areaId}/publish-updating-courses',
  AREA_ID_VERSIONS: 'update/areas/{areaId}/versions',
  AREAS_VERSIONS: 'update/versions',
  AREAS_WITHOUT_VERSION: 'update/areas/without-version',
  AREAS_CNAE_COURSE_ID: 'update/cnae-list/course-version/${courseVersionId}',
  AREAS_CNAE_AREA_VERSION_ID: 'update/cnae-list/area-version/${areaVersionId}',
  COURSE_VERSION_COMPETENCE:
    '/update/course-version/{courseVersionId}/competence',
  CURRENT_VERSION_COMPETENCE:
    '/update/current-version/{courseVersionId}/competence',
  COURSE_VERSION_ACCESS_REQUIREMENTS:
    '/update/course/{courseVersionId}/access-requirement',
  COURSE_VERSION_IMPORT:
    'update/course-version/duplicate-single-course-version',
  COURSE_VERSION_PUBLISH:
    'update/course-version/{courseVersionId}/publish-course-version',
  COURSE_VERSION_DELETE: 'update/course-version/{courseVersionId}',
  ACCESS_REQUIREMENTS: '/update/access-requirement?description={description}',
  CNAE_SECTION: '/update/cnae-section-list',
  CNAE_SECTION_COURSE_VERSION_ID:
    '/update/cnae-section-list/{cnaeSectionId}/course-version/{courseVersionId}',
  CNAE_DIVISION: '/update/cnae-division-list/',
  CNAE_DIVISION_SIMPLE: '/update/cnae-division-list/registered/{sectionId}',
  CNAE_DIVISION_COURSE_VERSION_ID:
    '/update/cnae-division-list/{cnaeDivisionId}/course-version/{courseVersionId}',
  CNAE_GROUP: '/update/cnae-group-list/',
  CNAE_GROUP_SIMPLE: '/update/cnae-group-list/registered/{divisionId}',
  CNAE_GROUP_COURSE_VERSION_ID:
    '/update/cnae-group-list/{cnaeGroupId}/course-version/{courseVersionId}',
  BULK_DELETE_CNAE: '/update/cnae/course-version/{courseVersionId}/bulk',
  FUNCTION_ID: 'update/function/{functionId}',
  SUBFUNCTION_ID: 'update/subfunction/{subfunctionId}',
  PERFORMANCE_STANDARD_ID:
    'update/performance-standard/{performanceStandardId}',
  PERFORMANCE_STANDARD_DESCRIPTION:
    '/performance-standard/{performanceStandardId}/description',
  PERFORMANCE_STANDARD_USAGE_COUNT:
    '/performance-standard/{performanceStandardId}/usage-count',
  EVOLUTION_ID: '/update/evolution-list/{id}',
  EVOLUTION_TYPE: '/evolution-type-list',
  RELATED_FORMATION_ID: '/update/professional-formation/{id}',
  CURRICULAR_UNIT_COURSE_VERSION:
    '/update/curricular-unit-list/{curricularUnitCourseVersionId}',
  DELETE_INFRASTRUCTURE_CURRICULAR_UNIT_COURSE_VERSION:
    'update/infrastructure-list/{infrastructureId}/curricular-unit-course-version/{curricularUnitCourseVersionId}', // Desvincula infraestrutura de unidade curricular
  COURSE_VERSION_ID: 'update/course-version/{courseVersionId}',
  POSITION_OF_FUNCTION_SUBFUNCTION_PERFORMANCE_STANDARD:
    'update/position-of-function-subfunction-performance-standard',
  MODULE_COURSE_VERSION: '/update/module-course-version',
  INFRASTRUCTURE_LIST: '/update/infrastructure-list',
  INFRASTRUCTURE_ID: '/update/infrastructure-list/{infrastructureId}',

  INFRASTRUCTURE_URL_CURRICULAR_UNIT_CV_LIST:
    '/update/curricular-unit-cv-list/{curricularUnitCvId}/infrastructure/{infrastructureId}/infrastructure-url-list',
  INFRASTRUCTURE_URL_CURRICULAR_UNIT_CV:
    '/update/curricular-unit-cv-list/infrastructure-url-list/{infrastructureUrlCurricularUnitCvId}',

  // Condições de Trabalho — Contexto de Trabalho
  WORK_CONDITION_CV_LIST:
    '/update/course-version/{courseVersionId}/work-condition-cv-list',
  WORK_CONDITION_LIST:
    '/update/course-version/{courseVersionId}/work-condition-list',

  // Meios de Produção — Contexto de Trabalho
  PRODUCTION_MEAN_CV_LIST:
    '/update/course-version/{courseVersionId}/production-mean-cv-list',
  PRODUCTION_MEAN_LIST:
    '/update/course-version/{courseVersionId}/production-mean-list',

  // Evoluções da Ocupação — Contexto de Trabalho
  EVOLUTION_CV_LIST:
    '/update/course-version/{courseVersionId}/evolution-cv-list',
  EVOLUTION_LIST_CREATE:
    '/update/course-version/{courseVersionId}/evolution-list',

  // Formações Relacionadas — Contexto de Trabalho
  PROFESSIONAL_FORMATION_LIST:
    '/update/course-version/{courseVersionId}/professional-formation-list',
  PROFESSIONAL_FORMATION_ID_DELETE:
    '/update/course-version/{courseVersionId}/professional-formation-list/{professionalFormationId}',
  CURRICULAR_UNIT_CURRENT_VERSION:
    '/curricular-unit-cv/{curricularUnitCourseVersionId}/current-version',
  INTERMEDIATE_EXIT_CREATE:
    '/update/course-version/{courseVersionId}/intermediate-exit-list',
  INTERMEDIATE_EXIT_UPDATE:
    '/update/intermediate-exit-list/{intermediateExitId}',
  INTERMEDIATE_EXIT_DELETE:
    '/update/intermediate-exit-list/{intermediateExitId}',
  INTERMEDIATE_EXIT_SEARCH:
    '/update/course-version/{courseVersionId}/intermediate-exit-list/search',
  CAPACITY_UPDATE: '/update/capacity-list/{capacityId}',
  CAPACITY_AFFECTED_COURSES_COUNT:
    '/update/capacity-list/{capacityId}/affected-courses-count',
} as const
